export enum RequestType {
  PING = 'ping', AUTH = 'auth', SUB = 'sub', UNSUB = 'unsub'
}

export interface Header {
  type: RequestType;
  clientId?: string;
  messageId?: string;
}

export interface AuthBody {
  token: string;
}

export interface SubscribeBody {
  channel: string;
}

export interface PingBody {
  pingTz: Date;
}

export interface UnsubscribeBody {
  subscriptionId: string;
}

export interface Message {
  header: Header;
  body: AuthBody | SubscribeBody | UnsubscribeBody | PingBody;
}

export interface Event {
  channel: string;
  subscriptionId: string;
  data: any;
}
